import { useState, useEffect } from 'react';
import axios from 'axios';
import routes from 'app/routes';

function sortCategories(arr) {
  return arr.sort((a, b) => b.type.localeCompare(a.type) || a.name.localeCompare(b.name));
}

function uniqAndSortCategories(arr) {
  const uniqArr = [];
  arr.forEach((item) => {
    if (!uniqArr.find((o) => o.id === item.id)) {
      uniqArr.push(item);
    }
  });

  return sortCategories(uniqArr);
}

export default function useLoadTopics(params) {
  const [loading, setLoading] = useState(true);
  const [topics, setTopics] = useState([]);

  const categories = uniqAndSortCategories(
    topics.filter((item) => item.attributes.special_type !== 'employee_choice')
      .map((item) => ({
        id: item.attributes.topic_category_id,
        name: item.attributes.topic_category_name,
        type: item.attributes.topic_category_type,
        icon: item.attributes.topic_category_icon,
      })),
  );

  useEffect(() => {
    axios
      .get(routes.api.topics.index, { params })
      .then((resp) => {
        setLoading(false);
        setTopics(resp.data.data);
      });
  }, []);

  return { loading, topics, categories };
}
